import axios from 'axios'
import { BASE_API, ROLE } from '../constants'
import Helper from '../services/Helper'

const isNullOrEmpty = Helper.isNullOrEmpty

axios.defaults.baseURL = BASE_API
axios.defaults.headers.common['token'] = localStorage.getItem('token')

const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
}
//Auth
function login(data) {
    return axios.post('/login', data)
}

function logout(){
    return axios.get('/logout')
}

function verifyOtp(data) {
  return axios.post('/verify-otp', data)
}

function getTokenForgotPassword(props) {
    let formData = props.formData || {}
    return axios.post('/forgot-password', formData)
}

function validateTokenForgotPassword(props) {
    let formData = props.formData || {}
    return axios.put('/forgot-password', formData)
}

function userChangePassword(props) {
    let formData = props.formData || {}
    return axios.put('/user-change-password', formData)
}

//===========================================
// MASTER PERUSAHAAN
//===========================================
function getPerusahaan(paramEncoded) {
    return axios.get(`/perusahaan?${paramEncoded}`)
}
function getPerusahaanLimit(paramEncoded) {
    return axios.get(`/perusahaan-limit?${paramEncoded}`)
}
function getPerusahaanDetail(id, params) {
    if(!params) params = ''
    return axios.get(`/perusahaan/${id}?${params}`)
}

function getPerusahaanDetailFormTemuan(props) {
    let perusahaanId = props.perusahaanId || null
    let params = props.params || null
    return axios.get(`/perusahaan/form-temuan/${perusahaanId}?${params}`)
}

const postFieldsPerusahaan = [
    'nama',
    'masterJenisPerusahaanId',
    'masterProvinsiId',
    'alamat',
    'teleponFax',
    'luasTanahBangunan',
    'jumlahKaryawan',
    'produk',
    'directorInCharge',
    'managementRepresentative',
    'personInCharge',
    'masterParentPerusahaanId',

    'username1',
    'email1',
    'password1',
    'retypePassword1',
    'roleId1', // untuk user
    'username2',
    'email2',
    'password2',
    'retypePassword2',
    'roleId2', // untuk user
]

function createMasterPerusahaan(data) {
    let formData = {}
    let postFields = postFieldsPerusahaan
    for (let field of postFields) {
        formData[field] = data[field]
    }
    return axios.post('/perusahaan', formData)
}

function updateMasterPerusahaan(id, data) {
    return axios.put(`/perusahaan/${id}`, data)
}
function deleteMasterPerusahaan(id) {
    return axios.delete(`/perusahaan/${id}`)
}
function getJenisPerusahaan(paramEncoded) {
    return axios.get(`/jenis-perusahaan-all?${paramEncoded}`)
}

function getUserAsessorOnPerusahaan(id, params) {
    return axios.get(`/perusahaan/${id}/users?${params}&roleId=6`)
}

function createUserPerusahaan(data) {
    let formData = {}
    let postFields = ['userId', 'masterPerusahaanId']

    for (let field of postFields) {
        formData[field] = data[field]
    }
    return axios.post('/user-perusahaan', formData)
}

function selectAllUserPerusahaan(props = {}) {
    let formData = props.formData || {}
    return axios.post('/user-perusahaan/all', formData)
}
function deleteUserPerusahaan(id) {
    return axios.delete(`/user-perusahaan/${id}`)
}

function deleteUserPerusahaanAll(data) {
    let formData = {}
    let postFields = ['userId']
  
    for (let field of postFields) {
      formData[field] = data[field]
    }
  
    return axios.post(`/delete-all-user-perusahaan`, formData)
  }

//===========================================
// MASTER USER
//===========================================
function getRole(paramEncoded) {
    return axios.get(`/role?${paramEncoded}`)
}
function getUser(paramEncoded) {
    return axios.get(`/user?${paramEncoded}`)
}

function getUserDetail(id, params) {
    return axios.get(`/user/${id}?${params}`)
}

const postFieldsUser = [
    'username',
    'email',
    'password',
    'retypePassword',
    'roleId',
    'masterPerusahaanId',
    'masterPerusahaanIds',
    'adminId',
    'multipleRoles',
    'noTelpon',
    'masterParentPerusahaanId',
]

function createMasterUser(data) {
    let formData = {}
    let postFields = postFieldsUser

    for (let field of postFields) {
        formData[field] = data[field]
    }
    return axios.post('/user', formData)
}

function updateMasterUser(id, data) {
    let formData = {}

    let postFields = postFieldsUser

    for (let field of postFields) {
        formData[field] = data[field]
    }
    return axios.put(`/user/${id}`, formData)
}

function actionMasterUser(id, action) {
    return axios.put(`/user/${action}/${id}`)
}

function deleteMasterUser(id) {
    return axios.delete(`/user/${id}`)
}

function getPerusahaanOnUser(id, params) {
    return axios.get(`/user/${id}/perusahaan?${params}`)
}

//===========================================
// MASTER SHEET
//===========================================
function getSheet(paramEncoded) {
    return axios.get(`/sheet?${paramEncoded}`)
}

function createSheet(data) {
    let formData = {}
    let postFields = ['nama', 'typePenilaian']
    for (let field of postFields) {
        formData[field] = data[field]
    }
    return axios.post('/sheet', formData)
}

function updateSheet(id, data) {
    let formData = {}
    let postFields = ['nama', 'typePenilaian']
    for (let field of postFields) {
        formData[field] = data[field]
    }
    return axios.put(`/sheet/${id}`, formData)
}

function getKriteria(paramEncoded) {
    return axios.get(`/kriteria?${paramEncoded}`)
}

function getKriteriaAgc(data) {
    let { tahun, masterJenisPerusahaanId } = data
    return axios.get(`/kriteria-agc/${tahun}/${masterJenisPerusahaanId}`)
}

function getSubKriteriaAgc(data) {
    let { masterKriteriaId } = data
    return axios.get(`/subkriteria-agc/${masterKriteriaId}`)
}

function getProvinsi(paramEncoded) {
    return axios.get(`/provinsi?${paramEncoded}`)
}

function getSheetPerusahaan(paramEncoded) {
    return axios.get(`/sheet-perusahaan?${paramEncoded}`)
}

function fetchSheetPerusahaan(props) {
    let params = props.params || ''
    return axios.get(`/sheet/perusahaan?${params}`)
}

function sheetPerusahaan(params, paramEncoded) {
    return axios.get(
        `/sheet-perusahaan/${params.masterJenisPerusahaanId}/${params.tahunId}?${paramEncoded}`
    )
}

function getSheetTahun() {
    return axios.get(`/sheet-tahun`)
}

function getListKriteria(paramEncoded) {
    return axios.get(`/sheet/list-kriteria?${paramEncoded}`)
}

function getListSubKriteria(paramEncoded) {
    return axios.get(`/sheet/list-sub-kriteria?${paramEncoded}`)
}

function createJenisSheet(data) {
    let formData = {}
    let postFields = ['masterJenisPerusahaanId', 'masterSheetId']
    for (let field of postFields) {
        formData[field] = data[field]
    }
    return axios.post('/jenis-sheet', formData)
}

function getPertanyaanPerSheet(
    masterPerusahaanId,
    masterSheetId,
    params = null
) {
    return axios.get(
        `/pertanyaan/${masterPerusahaanId}/${masterSheetId}?${params}`
    )
}

function updatePenilaian(id, data) {
    let formData = new FormData()
    if (data.bukti) formData.append('bukti', data.bukti)
    if (data.komentar || data.komentar === '')
        formData.append('komentar', data.komentar)
    if (data.nilai || data.nilai === '') formData.append('nilai', data.nilai)
    if (data.confirm === true || data.confirm === false)
        formData.append('confirm', data.confirm)

    let dataField = [
        'nilaiAkhir',
        'nilaiDetail',
        'status',
        //khusus form angka ////////////
        'totalSE',
        'totalA',
        'persentaseAkhir',
        //khusus form FRSR /////////////
        'bulan',
        'periode',
        'jumlahKaryawan',
        'jumlahJamKerja',
        'jumlahJamKerjaKaryawan',
        'jumlahKecelakaan',
        'jumlahHariHilang',
        'totalJumlahKaryawan',
        'totalJumlahJamKerja',
        'totalJumlahJamKerjaKaryawan',
        'totalJumlahKecelakaan',
        'totalJumlahHariHilang',
        'jumlahKaryawanBulanAkhir',
        'FR',
        'SR',
        //khusus form TKTF /////////////
        'totalVolumeLaluLintas',
        'totalAverageJarakTempuh',
        'totalAveragePerBulan',
        'totalDampakLukaRingan',
        'totalDampakLukaBerat',
        'totalDampakMati',
        'TK',
        'TF',
        'volume_lalu_lintas',
        'average_jarak_tempuh',
        'average_per_bulan',
        'jumlah_kecelakaan',
        'dampak_luka_ringan',
        'dampak_luka_berat',
        'dampak_mati',
    ]

    for (let field of dataField) {
        if (!isNullOrEmpty(data[field]))
            formData.append(`${field}`, data[field])
    }

    return axios.put(`/penilaian-asessor/${id}`, formData, config)
}

function updateDataLocal(data) {
    return axios.post('/penilaian-asessor/update-data-local', data)
}

function updatePenilaianPeriode(data) {
    return axios.put(`/periode-penilaian-asessor`, data)
}

function updateExecutiveSummary(props) {
    let executiveSummaryId = props.executiveSummaryId || null
    let formData = props.formData || {}

    return axios.put(`/executive-summary/${executiveSummaryId}`, formData)
}
function getNilaiCapaian(props) {
    const masterPerusahaanId = props.masterPerusahaanId || null
    const params = props.params || null
    return axios.get(
        `/executive-summary/nilai-capaian/${masterPerusahaanId}?${params}`
    )
}

function getExecutiveSummary(paramEncoded) {
    return axios.get(`/executive-summary?${paramEncoded}`)
}
function saveKomentarAstra(data) {
    return axios.put('/executive-summary/save-komentar-astra', data)
}

function generatePdf(data) {
    let keys = Object.keys(data)
    let params = []
    if (typeof keys === 'object' && keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
            params.push(`${keys[i]}=${data[keys[i]]}`)
        }
    }
    params = encodeURI(params.join('&'))

    return axios.get(`/generate-pdf?${params}`)
}

function generatePerusahaan(data) {
    return axios.post(`/generate-pdf/perusahaan`, data)
}

function getTahun(paramEncoded) {
    return axios.get(`/tahun?${paramEncoded}`)
}

function getTahunJenisPerusahaan(masterJenisPerusahaanId) {
    return axios.get(`/jenis-perusahaan/tahun/${masterJenisPerusahaanId}`)
}

function deleteJenisPerusahaan(data) {
    let { tahun, masterJenisPerusahaanId } = data
    return axios.delete(
        `/jenis-perusahaan/delete/${tahun}/${masterJenisPerusahaanId}`
    )
}

function getNilaiFrSr(perusahaanId) {
    return axios.get(`/nilai-fr-sr/${perusahaanId}`)
}

function getFrSr(perusahaanId, query) {
    return axios.get(
        `/fr-sr/${perusahaanId}?idfr=${query.idfr}&idsr=${query.idsr}&tahun=${query.tahun}`
    )
}

function pimpinanApprove(data) {
    return axios.post('/pimpinan-approve', data)
}
function astraApprove(data) {
    return axios.post('/astra-approve', data)
}
function picEditable(id, data) {
    return axios.put(`/pic-editable/${id}`, data)
}
function changeJenisAssessment(id, data) {
    return axios.put(`/perusahaan/jenis-assessment/${id}`, data)
}
function kepalaApprove(data) {
    return axios.post('/executive-summary/kepala-approve', data)
}
function getStatistikNilaiPerTahun(params) {
    let account = Helper.getUser()
    let masterPerusahaanIds = account.roleId === ROLE.ADMIN_PUSAT ? [] : account.masterPerusahaanIds

    return axios.get(
        `/statistik-nilai?${params}&masterPerusahaanIds=${masterPerusahaanIds}`
    )
}
function getStatistikNilaiRangeTahun(props) {
    let params = props.params || ''
    if (params) params += '&'
    let account = Helper.getUser()
    let masterPerusahaanIds = []
    if (
        Array.isArray(account.masterPerusahaanIds) &&
        account.masterPerusahaanIds.length > 0
    ) {
        masterPerusahaanIds = account.masterPerusahaanIds
    }
    if (
        Array.isArray(props.masterPerusahaanIds) &&
        props.masterPerusahaanIds.length > 0
    ) {
        masterPerusahaanIds = props.masterPerusahaanIds
    }
    masterPerusahaanIds = account.roleId === ROLE.ADMIN_PUSAT ? [] : account.masterPerusahaanIds

    return axios.get(
        `/statistik-nilai/range?${params}masterPerusahaanIds=${masterPerusahaanIds}`
    )
}

function getStatistikNilaiRangeTahunPerPerusahaan(params) {
    return axios.get(`/statistik-nilai-perusahaan/range?${params}`)
}
function getPetaStatus(params) {
    let account = Helper.getUser()
    const masterPerusahaanIds = account.roleId === ROLE.ADMIN_PUSAT ? [] : account.masterPerusahaanIds

    return axios.get(
        `/peta-status?${params}&masterPerusahaanIds=${masterPerusahaanIds}`
    )
}

function getMasterPertanyaan(sheetPerusahaanId) {
    return axios.get(`/get-master-pertanyaan/${sheetPerusahaanId}`)
}
function editKriteria(data) {
    return axios.post('/edit-kriteria', data)
}
function editSubKriteria(data) {
    return axios.post('/edit-sub-kriteria', data)
}
function editPertanyaan(data) {
    return axios.post('/edit-pertanyaan', data)
}
function addPertanyaan(data) {
    return axios.post('/sheet/add-pertanyaan', data)
}
function addKriteria(data) {
    return axios.post('/sheet/add-kriteria', data)
}
function addSubKriteria(data) {
    return axios.post('/sheet/add-sub-kriteria', data)
}
function deletePertanyaan(data) {
    return axios.post('/sheet/delete-pertanyaan', data)
}
function deleteKriteria(data) {
    return axios.post('/sheet/delete-kriteria', data)
}
function deleteSubKriteria(data) {
    return axios.post('/sheet/delete-sub-kriteria', data)
}
function sortPertanyaan(id, data) {
    return axios.put(`/sheet/sort-pertanyaan/${id}`, data)
}
function sortKriteria(id, data) {
    return axios.put(`/sheet/sort-kriteria/${id}`, data)
}
function sortSubKriteria(id, data) {
    return axios.put(`/sheet/sort-sub-kriteria/${id}`, data)
}
function uploadPhotoFormTemuan(data) {
    let formData = new FormData()
    let keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
        let name = keys[i]
        formData.append(name, data[name])
    }
    return axios.post('/form-temuan/upload-photo', formData)
}
function updatePhotoFormTemuan(data) {
    let formData = new FormData()
    let keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
        let name = keys[i]
        formData.append(name, data[name])
    }
    return axios.post('/form-temuan/update-photo', formData)
}
function addPhoto2Temuan(data) {
    let formData = new FormData()
    let keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
        let name = keys[i]
        formData.append(name, data[name])
    }
    return axios.post('/form-temuan/add-photo-2', formData)
}
function updatePhoto2FormTemuan(data) {
    let formData = new FormData()
    let keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
        let name = keys[i]
        formData.append(name, data[name])
    }
    return axios.post('/form-temuan/update-photo-2', formData)
}
function updateStatusTemuan(data) {
    return axios.post('/form-temuan/update-status', data)
}

function createTemuan(props) {
    let formData = new FormData()
    if (props.formData) {
        Object.entries(props.formData).map((item, index) => {
            let [key, value] = item
            if (value || value === null || value === 0 || value === false) {
                if (
                    typeof value === 'object' &&
                    value !== null &&
                    !(value instanceof File)
                )
                    value = JSON.stringify(value)
                formData.append(key, value)
            }
        })
    }
    return axios.post('/form-temuan', formData)
}
function updateTemuan(props) {
    let formTemuanId = props.formTemuanId || null
    let formData = new FormData()
    if (props.formData) {
        Object.entries(props.formData).map((item, index) => {
            let [key, value] = item
            if (value || value === null || value === 0 || value === false) {
                if (
                    typeof value === 'object' &&
                    value !== null &&
                    !(value instanceof File)
                )
                    value = JSON.stringify(value)
                formData.append(key, value)
            }
        })
    }
    return axios.put(`/form-temuan/${formTemuanId}`, formData)
}
function deleteFormTemuan(props) {
    let formTemuanId = props.formTemuanId || null
    return axios.delete(`/form-temuan/${formTemuanId}`)
}
function addHeaderTemuan(data) {
    return axios.post('/form-temuan/header', data)
}
function updateHeaderFormTemuan(props) {
    let headerFormTemuanId = props.headerFormTemuanId || null
    let formData = props.formData || null
    return axios.put(`/form-temuan/update/${headerFormTemuanId}`, formData)
}
function deleteHeaderTemuan(props) {
    let headerFormTemuanId = props.headerFormTemuanId || null
    return axios.delete(`/form-temuan/header/${headerFormTemuanId}`)
}

function getFormTemuan(data) {
    let { masterPerusahaanId, tahun } = data

    return axios.get(`/form-temuan/${masterPerusahaanId}/${tahun}`)
}

function uploadGambarHome(data) {
    let formData = new FormData()
    let { gambarhome } = data
    formData.append('gambarhome', gambarhome)
    return axios.post('/upload-gambar-home', formData)
}
function getGambarHome() {
    return axios.get('/gambar-home')
}
function generateTahun(tahun, option = {}) {
    let params = '?' + option.params || ''
    return axios.get(`/tahun/generate/${tahun}${params}`)
}
function getStatistikTahun(tahun) {
    return axios.get(`/tahun/statistik/${tahun}`)
}
function deleteTahun(tahun) {
    return axios.delete(`/tahun/${tahun}`)
}
function generateJenisPerusahaan(data) {
    let {
        tahun,
        masterJenisPerusahaanId,
        namaJenisPerusahaan,
        nomorKriteria,
    } = data
    return axios.post(`/generate/jenis-perusahaan`, data)
}

function getNilaiTkTf(data) {
    return axios.post('/nilai/tk-tf', data)
}

function updateNilaiBeyond(id, data) {
    return axios.put(`/update-nilai-beyond/${id}`, data)
}

function getSheetJenisPerusahaan(props) {
    let params = props.params || ''

    return axios.get(`/jenis-perushaan-sheet?${params}`)
}

function createJenisPerusahaan(props) {
    let data = props.data || {}
    return axios.post(`/master-jenis-perusahaan`, data)
}

function deleteSheetJenisPerusahaan(data) {
    return axios.delete(
        `/master-jenis-perusahaan/${data.masterJenisPerusahaanId || ''}/${
            data.masterSheetId || ''
        }`
    )
}

function editSheetJenisPerusahaan(data) {
    return axios.put(
        `/master-jenis-perusahaan/${data.masterJenisPerusahaanId}`,
        data
    )
}

function getMasterSheet(props) {
    return axios.get(`/sheet`)
}

function getJumlahSheet(props) {
    return axios.get('/jumlah-sheet')
}

function cloningSheet() {
    return axios.get('/cloning-sheet')
}

function deletePrevSheet() {
    return axios.get('/delete-prev-sheet')
}

function getDetailSheetPerusahaan(props) {
    let masterSheetId = props.masterSheetId || ''
    let params = props.params || ''
    return axios.get(`/sheet/perusahaan/${masterSheetId}?${params}`)
}

function getDetailSheet(props) {
    let masterSheetId = props.masterSheetId || ''
    let params = props.params || ''
    return axios.get(`/sheet/${masterSheetId}?${params}`)
}

function getPersepsiSheet(props) {
    let masterPerusahaanId = props.masterPerusahaanId || null
    let params = props.params || ''
    return axios.get(`/sheet/persepsi/${masterPerusahaanId}?${params}`)
}
function createPersepsiSheet(props) {
    let masterPerusahaanId = props.masterPerusahaanId || null
    let formData = props.formData || {}
    return axios.post(`/sheet/persepsi/${masterPerusahaanId}`, formData)
}

function deletePersepsiSheet(props) {
    let sheetPerusahaanId = props.sheetPerusahaanId || null
    return axios.delete(`/sheet/persepsi/${sheetPerusahaanId}`)
}

function postPenilaianAssessor(prosp) {
    return axios.post('/penilaian-assessor', prosp.formData)
}

function deletePenilaianAssessor(assessorId) {
    return axios.delete(`/penilaian-assessor/${assessorId}`)
}

function getSettings(props) {
    let params = props.params || ''
    return axios.get(`/settings?${params}`)
}

function updateSetting(props) {
    const settingId = props.settingId || null
    const formData = props.formData || {}
    return axios.put(`/setting/${settingId}`, formData)
}

function getLogs(props) {
    let params = props.params || ''
    return axios.get(`/logs?${params}`)
}

function getLogsByPerusahaan(id, params) {
    return axios.get(`/perusahaan/${id}/logs?${params}`)
}

function getRekapSheet(props) {
    let masterPerusahaanId = props.masterPerusahaanId || ''
    let params = props.params || ''
    return axios.get(`/rekapitulasi-sheet/${masterPerusahaanId}?${params}`)
}

function getPerameterSinkron(props) {
    let masterPerusahaanId = props.masterPerusahaanId || null
    return axios.get(`/perusahaan/parameter-sinkron/${masterPerusahaanId}`)
}

function sinkronisasiNilaiPerusahaan(props) {
    let masterPerusahaanId = props.masterPerusahaanId || null
    return axios.get(`/perusahaan/sinkronisasi-nilai/${masterPerusahaanId}`)
}

function synchronizeNilaiPerPerusahaan(props) {
    return axios.get(
        `/synchronize-nila-perusahaan/${props.masterPerusahaanId || ''}?${
            props.params || ''
        }`
    )
}

function getMetadataGenerateTahun(props) {
    return axios.get('/metadata-generate-tahun')
}

function postStageAssessment(props) {
    let formData = props.formData || {}
    return axios.post('/stage', formData)
}

function nonActiveSelftAssessment(props) {
    let formData = props.formData || {}
    return axios.post('/perusahaan/non-active-self-assessment', formData)
}

function getInfoUser(props) {
    return axios.get('/info-user')
}

function changeRoleMulti(props) {
    let roleId = props.roleId || null
    return axios.post('/change-role-multi', { roleId })
}

function getDetailMasterJenisKriteria(props) {
    let masterJenisPerusahaanId = props.masterJenisPerusahaanId || null
    return axios.get(`/master-jenis-kriteria/${masterJenisPerusahaanId}`)
}

function deleteSheetPerusahaan(props) {
    let sheetPerusahaanId = props.sheetPerusahaanId || null
    return axios.delete(`/sheet-perusahaan/${sheetPerusahaanId}`)
}

function updateJenisPerusahaan(props) {
    let formData = props.formData || {}
    let masterJenisPerusahaanId = props.masterJenisPerusahaanId || null
    return axios.put(`/jenis-perusahaan/${masterJenisPerusahaanId}`, formData)
}

function getMasterParentPerusahaan(props = {}) {
    let params = props.params || ''
    return axios.get(`/parent-perusahaan?${params}`)
}

function createMasterParentPerusahaan(props) {
    let formData = props.formData || {}
    return axios.post('/parent-perusahaan', formData)
}

function updateMasterParentPerusahaan(props) {
    let formData = props.formData || {}
    return axios.put('/parent-perusahaan', formData)
}

function deleteMasterParentPerusahaan(props) {
    let formData = props.formData || {}
    return axios.delete(`/parent-perusahaan/${formData.id}`)
}

function getSinkronisasiNilaiPerusahaan(props) {
    let params = props.params || ''
    return axios.get(`/sinkronisasi-nilai-perusahaan?${params}`)
}

function updatePersetujuanKepala(props) {
    let masterPerusahaanId = props.masterPerusahaanId || ''
    let formData = props.formData || {}
    return axios.put(
        `/perusahaan/persetujuan-kepala/${masterPerusahaanId}`,
        formData
    )
}

function getDetailPenilaianAssessor(props) {
    let penilaianAssessorId = props.penilaianAssessorId || null
    return axios.get(`/penilaian-assessor/${penilaianAssessorId}`)
}

function deleteFileBukti(props) {
    const fileId = props.fileId || null
    return axios.delete(`/file-bukti/${fileId}`)
}

function akumulasiNilaiSheetPerusahaan(props) {
    let params = props.params || ''
    return axios.get(`/nilai-sheet/perusahaan/akumulasi?${params}`)
}

function updateNilaiSheetPerusaahaan(props) {
    let formData = props.formData || {}
    let nilaiSheetPerusahaanId = props.nilaiSheetPerusahaanId || ''
    return axios.put(
        `/nilai-sheet/perusahaan/${nilaiSheetPerusahaanId}`,
        formData
    )
}

function updateKriteriaPertanyaan(props) {
    let masterKriteriaPertanyaanId = props.masterKriteriaPertanyaanId || null
    let formData = props.formData || {}
    return axios.put(
        `/kriteria-pertanyaan/${masterKriteriaPertanyaanId}`,
        formData
    )
}
function updatePertanyaan(props) {
    let pertanyaanId = props.pertanyaanId || null
    let formData = props.formData || {}
    return axios.put(`/pertanyaan/${pertanyaanId}`, formData)
}

function getTigaTahun() {
    return axios.get('/tahun/tiga-tahun')
}

function getLogsApp(params) {
  params = params || ''
  return axios.get(`/logs-app?${params}`)
}

function downloadLogsApp(filename) {
  return axios.get(`/logs-app/${filename}`)
}

const ApiCall = {
    getTigaTahun,
    updatePertanyaan,
    updateKriteriaPertanyaan,
    updateNilaiSheetPerusaahaan,
    akumulasiNilaiSheetPerusahaan,
    getDetailPenilaianAssessor,
    fetchSheetPerusahaan,
    selectAllUserPerusahaan,
    getTokenForgotPassword,
    validateTokenForgotPassword,
    userChangePassword,
    getPersepsiSheet,
    createPersepsiSheet,
    deletePersepsiSheet,

    updatePersetujuanKepala,
    getSinkronisasiNilaiPerusahaan,

    getMasterParentPerusahaan,
    createMasterParentPerusahaan,
    updateMasterParentPerusahaan,
    deleteMasterParentPerusahaan,

    login,
    logout,
    verifyOtp,
    
    getRole,
    getUser,
    getUserDetail,
    createMasterUser,
    updateMasterUser,
    actionMasterUser,
    deleteMasterUser,
    getPerusahaanOnUser,

    getPerusahaan,
    getPerusahaanLimit,
    getPerusahaanDetail,
    createMasterPerusahaan,
    updateMasterPerusahaan,
    deleteMasterPerusahaan,
    getJenisPerusahaan,
    getUserAsessorOnPerusahaan,
    createUserPerusahaan,
    deleteUserPerusahaan,
    deleteUserPerusahaanAll,
    picEditable,

    getProvinsi,

    getSheet,
    createSheet,
    updateSheet,
    getKriteria,
    getKriteriaAgc,
    getSubKriteriaAgc,

    getSheetPerusahaan,
    sheetPerusahaan,
    createJenisSheet,
    getSheetTahun,

    getPertanyaanPerSheet,

    getListKriteria,
    getListSubKriteria,

    updatePenilaian,
    deleteFileBukti,
    updateDataLocal,
    updatePenilaianPeriode,

    updateExecutiveSummary,
    getExecutiveSummary,
    saveKomentarAstra,
    generatePdf,
    generatePerusahaan,

    getTahun,

    getFrSr,
    getNilaiFrSr,

    getStatistikNilaiPerTahun,
    getStatistikNilaiRangeTahun,
    getStatistikNilaiRangeTahunPerPerusahaan,
    getPetaStatus,

    pimpinanApprove,
    astraApprove,
    kepalaApprove,

    getMasterPertanyaan,

    editKriteria,
    editSubKriteria,
    editPertanyaan,
    addPertanyaan,
    addKriteria,
    addSubKriteria,
    deletePertanyaan,
    deleteKriteria,
    deleteSubKriteria,
    sortPertanyaan,
    sortSubKriteria,
    sortKriteria,

    uploadPhotoFormTemuan,
    updateStatusTemuan,
    getFormTemuan,
    addHeaderTemuan,
    addPhoto2Temuan,
    deleteFormTemuan,
    updateHeaderFormTemuan,
    updatePhotoFormTemuan,
    updatePhoto2FormTemuan,
    deleteHeaderTemuan,
    updateTemuan,
    createTemuan,

    uploadGambarHome,
    getGambarHome,

    generateTahun,
    getTahunJenisPerusahaan,
    deleteJenisPerusahaan,
    deleteTahun,
    generateJenisPerusahaan,
    getStatistikTahun,

    getNilaiTkTf,
    updateNilaiBeyond,

    getSheetJenisPerusahaan,

    createJenisPerusahaan,
    getMasterSheet,
    deleteSheetJenisPerusahaan,
    editSheetJenisPerusahaan,

    getJumlahSheet,
    cloningSheet,
    deletePrevSheet,
    getDetailSheetPerusahaan,
    getDetailSheet,

    postPenilaianAssessor,
    deletePenilaianAssessor,
    
    getSettings,
    updateSetting,
    getLogs,
    getLogsByPerusahaan,

    getRekapSheet,

    getPerameterSinkron,
    sinkronisasiNilaiPerusahaan,
    getMetadataGenerateTahun,
    synchronizeNilaiPerPerusahaan,
    postStageAssessment,
    changeJenisAssessment,
    nonActiveSelftAssessment,
    getInfoUser,
    changeRoleMulti,

    getDetailMasterJenisKriteria,
    deleteSheetPerusahaan,
    updateJenisPerusahaan,
    getPerusahaanDetailFormTemuan,
    getNilaiCapaian,
    getLogsApp,
    downloadLogsApp,
}

export default ApiCall
